import React from "react";
import { InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  customTextField: {
    "& .MuiOutlinedInput-root": {
      padding: "5px", // Reduce padding to minimize height
    //   fontSize: "12px",
      height: "34px",
      width: 250
    
    },

    // Border color in default mode
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1976da80",
      borderRadius: "10px",
    },

    // Border color in default mode on hover
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#4154f1 !important",
    },

    // Border color when focused
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#4154f1",
      border: "1px solid  #4154f1",
    },

    // Placeholder color
    "& .MuiInputBase-input::placeholder": {
      color: "#4154f1", // Change this to your desired color
      fontSize: 12, // You can also adjust the font size for the placeholder
    },

    // Fontsize when typing in Textfield
    "& .MuiInputBase-input": {
      color: "#4154f1",
      fontSize: 11,
      fontWeight: "600",
      fontFamily: "'Roboto', sans-serif",
    },
  },
  searchIcon: {
    color: "#4154f1", // Change this to your desired icon color
  },
}));

export default function MuiTableSearch({
  id,
  placeholder,
  onChange,
  autoComplete,
}) {
  const classes = useStyles();
  return (
    <TextField
      className={classes.customTextField}
      variant="outlined"
      id="input-with-icon-textfield"
      placeholder={placeholder}
      size="small"
      onChange={onChange}
      autoComplete={autoComplete}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon className={classes.searchIcon} />
          </InputAdornment>
        ),
      }}
    />
  );
}
